<template>
  <div :class="['colcade', { 'loaded': !!instance }]" ref="colcade">
    <slot></slot>
  </div>
</template>

<script>
import Colcade from 'colcade'
import imagesLoaded from 'imagesloaded'

export default {
  name: 'Colcade',
  data () {
    return {
      instance: null
    }
  },
  mounted () {
    if (this.$refs.colcade) {
      imagesLoaded(this.$refs.colcade, () => {
        this.instance = new Colcade(this.$refs.colcade, {
          columns: '.grid-col',
          items: '.grid-item'
        })
      })
    }
  },
  beforeDestroy () {
    if (this.instance) {
      this.instance.destroy()
    }
  }
}
</script>

<style scoped>
.colcade:not(.loaded) {
  opacity: 0;
}
</style>